import React from 'react';

import { string, arrayOf, bool, shape, func } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';
import LoadingSpinner from '../loading_spinner/LoadingSpinner';

import './Listing.scss';

import {
  Table,
  TableRow,
  TableHeader,
  TableHead,
  TableFoot,
  TableBody,
  TableData
} from '../../table';

import Pagination from '../pagination/Pagination';

/**
 * @deprecated
 */
export default class Listing extends BaseComponent {
  render() {
    const {
      columns,
      data,
      firstPage,
      lastPage,
      loading,
      style,
      id,
      className,
      onPreviousClick,
      onNextClick
    } = this.props;

    const classNames = ClassNames('Listing', className);

    const visibleClass = loading ? 'on-loading' : '';

    return (
      <div style={style} id={id} className={classNames}>
        <div className={`overlay ${visibleClass}`}>
          <LoadingSpinner size="large" className="loading-spinner" />
        </div>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map(col => {
                return <TableHeader key={col.name}>{col.label}</TableHeader>;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, i) => {
              return (
                // Each row of data doesn't have a stable identity we can use as
                // a key, so fall back to using the index instead.
                // eslint-disable-next-line react/no-array-index-key
                <TableRow key={i}>
                  {columns.map(col => {
                    return (
                      <TableData key={col.name}>{row[col.name]}</TableData>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
          <TableFoot>
            <TableRow>
              <TableData
                className="listing-pagination"
                colSpan={columns.length}
              >
                <Pagination
                  disablePrev={firstPage}
                  disableNext={lastPage}
                  previousAction={onPreviousClick}
                  nextAction={onNextClick}
                />
              </TableData>
            </TableRow>
          </TableFoot>
        </Table>
      </div>
    );
  }
}

Listing.propTypes = {
  columns: arrayOf(shape({ name: string, label: string })),
  data: arrayOf(shape({})),
  firstPage: bool,
  lastPage: bool,
  loading: bool,
  style: shape({}),
  id: string,
  className: string,
  onPreviousClick: func,
  onNextClick: func
};

Listing.defaultProps = {
  columns: [], // [{label: string, name: string}]
  data: [], // [{key: value}]
  firstPage: true,
  lastPage: true,
  loading: false,
  style: {},
  id: undefined,
  className: undefined
};
